import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@bcc/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setDisconnectProductDialogTestId } from "./disconnect-product-dialog.utils";

export interface DisconnectProductDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  identifier: string;
  onConfirm: () => void;
  isPending?: boolean;
}

export const DisconnectProductDialog = ({ open, onOpenChange, identifier, onConfirm, isPending = false }: DisconnectProductDialogProps) => {
  const { t } = useTranslation();
  const testIds = setDisconnectProductDialogTestId();

  const handleConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent Radix from auto-closing so we can show a loading state while the
    // mutation is in flight. The parent controls `open`.
    event.preventDefault();
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent testId={testIds.content}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={testIds.title}>{t("views.productsTable.disconnect.title", { identifier })}</AlertDialogTitle>
          <AlertDialogDescription data-testid={testIds.body}>
            {t("views.productsTable.disconnect.body", { identifier })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel testId={testIds.cancel} disabled={isPending}>
            {t("views.productsTable.disconnect.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction testId={testIds.confirm} onClick={handleConfirm} disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
            {t("views.productsTable.disconnect.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
